<template>
  <div class="header">
    <div class="header__media">
      <img src="../assets/header-ac.jpeg" :alt="titulo" class="img-fluid" />
    </div>
    <div class="header__title container">
      <h1>{{ titulo }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    titulo: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_vw-tokens.scss";

.header {
  border-bottom: 1px solid $vw-border;

  &__media {
    width: 100%;
    aspect-ratio: 1920 / 810;
    max-height: 600px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;
    }
  }

  &__title {
    background: transparent;
    padding-block: 16px;

    @media (min-width: 1640px) {
      width: 100%;
      max-width: 1640px;
    }

    h1 {
      margin: 0;
      color: $vw-blue;
      font-family: "vw-head", Arial, Helvetica, sans-serif;
      font-weight: 700;
      font-size: 4em;
      line-height: $vw-lh-headline;
      letter-spacing: -0.015em;

      @media (max-width: 669px) {
        font-size: 2.6em;
      }
    }
  }
}
</style>
